import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPageHeatMap.module.less'
import PdfPage from '../PdfPage/PdfPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPageHeatMap(props: Props) {
  const { t } = useTranslation()
  useEffect(() => {
    props.onRendered(1)
  }, [])
  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-3/PDF-bg-3.jpg')} no={props.no}>
      <div className={styles.pdfPageHeatMap}>
        <img
          className={styles.cntTitle}
          src={commonUtils.getImagePath('PDFDownload/04.png')}
          alt=''
        />
        <img
          className={styles.circle}
          src={commonUtils.getImagePath('PDFDownload/pdf-page-3/page3-icon.png')}
        />
        <div className={styles.desc}>{t('dashboard.projectDetailPage.heatmapAnalysis')}</div>
      </div>
    </PdfPage>
  )
}

export default PdfPageHeatMap
